import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDriver } from "../context/DriverContext";
import axios from "axios";

export default function DriverLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchDriverProfile } = useDriver();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  // 🔹 Capture ?reason=... from URL and show it as error
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reason = params.get("reason");
    if (reason === "deactivated") {
      setError("Your account has been deactivated. Please contact admin.");
    }
  }, [location]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await axios.post(
        `${BASE_URL}/api/driver/login`,
        { email, password },
        { withCredentials: true }
      );

      // Fetch driver profile from backend and update context
      await fetchDriverProfile();

      navigate("/driver/interface");
    } catch (err) {
      //console.error("Driver login error:", err);
      setError(
        err.response?.data?.message || "Failed to login. Check credentials."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-100">
      <form
        onSubmit={handleLogin}
        className="bg-white p-6 rounded-xl shadow max-w-sm w-full"
      >
        <div className="flex justify-center mb-4">
          <img src="/images/logos/Exudee-logo.svg" alt="Logo" className="h-16" />
        </div>
        <h2 className="text-xl font-bold mb-4 text-center">Driver Login</h2>

        {/* 🔹 Show any error or deactivated notice here */}
        {error && (
          <div className="bg-red-100 text-red-600 text-sm px-3 py-2 rounded mb-3">
            {error}
          </div>
        )}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 px-3 py-2 border rounded"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-4 px-3 py-2 border rounded"
          required
        />

        <button
          type="submit"
          className={`w-full py-2 rounded text-white ${
            loading ? "bg-gray-500 cursor-not-allowed" : "bg-gray-800 hover:bg-gray-700"
          }`}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Log In"}
        </button>
      </form>
    </div>
  );
}
